// Ported verbatim from the reference games' ui/useIsMobile.js.
// Coarse pointer (touch) → mobile layout (fullscreen canvas + the info panel
// as a centered modal). Decided purely by input device, not window width, so
// it always agrees with the CSS's own `@media (pointer: coarse)` switch.

import { useSyncExternalStore } from "react";

const mq =
  typeof window !== "undefined"
    ? window.matchMedia("(pointer: coarse)")
    : null;

function subscribe(cb: () => void) {
  mq?.addEventListener("change", cb);
  return () => mq?.removeEventListener("change", cb);
}

export function useIsMobile(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => (mq ? mq.matches : false),
    () => false,
  );
}
